<ng-container [formGroup]="submitForm">
  <mat-form-field>
    <mat-label>{{ 'personal-data-form.text.name' | translate }}</mat-label>
    <input
      [formControlName]="FORM_NAME.NAME"
      matInput
      name="name"
      [autocomplete]="'off'"
    />
    <mat-error>
      <lib-error-message-wrapper
        [control]="controlName"
      ></lib-error-message-wrapper>
    </mat-error>
  </mat-form-field>

  <lib-spacer></lib-spacer>

  <mat-form-field>
    <mat-label>{{ 'personal-data-form.text.surname' | translate }}</mat-label>
    <input
      [formControlName]="FORM_NAME.SURNAME"
      matInput
      name="surname"
      [autocomplete]="'off'"
    />
    <mat-error>
      <lib-error-message-wrapper
        [control]="controlSurname"
      ></lib-error-message-wrapper>
    </mat-error>
  </mat-form-field>

  <lib-spacer></lib-spacer>

  <mat-form-field class="mat-form-field-pointer" (click)="dp.open()">
    <mat-label>{{ 'personal-data-form.text.birthday' | translate }}</mat-label>
    <input
      [formControlName]="FORM_NAME.BIRTHDAY"
      matInput
      [matDatepicker]="dp"
      readonly
      [max]="today"
      (dateChange)="changeDatePicker()"
    />
    <mat-icon matSuffix color="primary" style="margin-right: 5px"
      >calendar_today</mat-icon
    >
    <mat-datepicker
      #dp
      [touchUi]="true"
      startView="multi-year"
    ></mat-datepicker>
  </mat-form-field>
</ng-container>
